export default __webpack_public_path__ + "static/media/Group3.7f83c51c.svg";